import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import DealsOverview from './pages/DealsOverview';
import DealView from './pages/DealView';
import useTheme from './hooks/useTheme';
import ViewAllDeals from './pages/ViewAllDeals';
import ChangePassword from './pages/ChangePassword';
import CommitmentsClosingWithOutstandingConditions from './pages/CommitmentsClosingWithOutstandingConditions';
import AllUpcomingClosing from './pages/AllUpcomingClosing';
import PendingReview from './pages/PendingReview';
import YTDFundedDeals from './pages/YTDFundedDeals';
import SearchDeals from './pages/SearchDeals';
import { Suspense } from 'react';
import Loading from './components/Loading';
import TokenService from './services/tokenService'; // Add this import
import PropTypes from 'prop-types';
import { useAuth } from './context/AuthContext';
import LanguageHandler from './components/LanguageHandler';

// Create a PrivateRoute component
const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, passwordChangeRequired, loading } = useAuth();
  const token = TokenService.getAuthToken();

  if (loading) {
    return <Loading />; // Show a loading spinner while checking auth
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          // No token - redirect to login
          return <Redirect to="/" />;
        }

        if (passwordChangeRequired) {
          // Password change required - redirect to change password
          return <Redirect to="/changePassword" />;
        }

        if (isAuthenticated) {
          // Authorized - render component
          return <Component {...props} />;
        }

        // Not authorized - redirect to login
        return <Redirect to="/" />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired
};

function App() {
  useTheme();
  
  return (
    <Router basename="/">
      <LanguageHandler />
      <div id="pageContainer">
        <Navbar/>
        <Suspense fallback={<Loading />}>
          <Switch>  
            {/* Public Routes */}
            <Route exact path="/" component={Signin} />
            <Route exact path="/resetPassword" component={ResetPassword} />
            <Route exact path="/changePassword" component={ChangePassword} />
            <Route exact path="/signup" component={Signup} />
            
            {/* Protected Routes */}
            <PrivateRoute exact path="/home" component={Home} />
            <PrivateRoute exact path="/deals" component={DealsOverview} />
            <PrivateRoute exact path="/allDeals" component={ViewAllDeals} />
            <PrivateRoute exact path="/dview/:accountID" component={DealView} />
            <PrivateRoute 
              exact 
              path="/commitments-closing-with-outstanding-conditions" 
              component={CommitmentsClosingWithOutstandingConditions} 
            />
            <PrivateRoute exact path="/all-upcoming-closing" component={AllUpcomingClosing} />
            <PrivateRoute exact path="/pending-review" component={PendingReview} />
            <PrivateRoute exact path="/ytd-funded-deals" component={YTDFundedDeals} />
            <PrivateRoute exact path="/search-deals" component={SearchDeals} />

            {/* Catch all redirect */}
            <Redirect to="/" />
          </Switch>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;